module.exports = __webpack_public_path__ + "img/logo.e1b4f9c5.svg";